module.exports = __webpack_public_path__ + "img/animation3.74325fae.png";